function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useMemo, useState } from "react";
import { UI, panelFieldStyle } from "../../../builderUiTheme";
import { BLOCK_ICON_CATALOG, ICON_EMOJI_PRESETS, filterBlockIcons } from "../../constants/iconCatalog";
import BlockIcon from "../BlockIcon";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var panelInputStyle = _objectSpread({}, panelFieldStyle);
export default function IconPickerField(_ref) {
  var _BLOCK_ICON_CATALOG$f;
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? {} : _ref$content,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    onSelectSvg = _ref.onSelectSvg,
    onSelectEmoji = _ref.onSelectEmoji,
    onCustomSymbol = _ref.onCustomSymbol;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var _useState3 = useState(content !== null && content !== void 0 && content.iconName ? "library" : "emoji"),
    _useState4 = _slicedToArray(_useState3, 2),
    tab = _useState4[0],
    setTab = _useState4[1];
  var filteredIcons = useMemo(function () {
    return filterBlockIcons(query);
  }, [query]);
  var tabBtn = function tabBtn(id, label) {
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: function onClick() {
        return setTab(id);
      },
      style: {
        flex: 1,
        border: "none",
        borderBottom: tab === id ? "2px solid #101828" : "2px solid transparent",
        background: tab === id ? UI.tabActive : "transparent",
        color: tab === id ? UI.tabActiveText : UI.tabInactiveText,
        padding: "8px 6px",
        cursor: "pointer",
        fontFamily: "DM Sans, sans-serif",
        fontSize: 13,
        fontWeight: 500
      },
      children: label
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 12
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: 12,
        background: UI.surface,
        borderRadius: 8,
        border: "1px solid ".concat(UI.surfaceBorder)
      },
      children: [/*#__PURE__*/_jsx(BlockIcon, {
        content: content,
        style: style
      }), /*#__PURE__*/_jsx("div", {
        style: {
          fontSize: 12,
          color: "#64748b",
          lineHeight: 1.4
        },
        children: content !== null && content !== void 0 && content.iconName ? "Icon: ".concat(((_BLOCK_ICON_CATALOG$f = BLOCK_ICON_CATALOG.find(function (i) {
          return i.id === content.iconName;
        })) === null || _BLOCK_ICON_CATALOG$f === void 0 ? void 0 : _BLOCK_ICON_CATALOG$f.label) || content.iconName) : content !== null && content !== void 0 && content.symbol ? "Symbol: ".concat(content.symbol) : "No icon selected"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        borderBottom: "1px solid ".concat(UI.panelBorder)
      },
      children: [tabBtn("library", "Icon Library"), tabBtn("emoji", "Emoji"), tabBtn("custom", "Custom")]
    }), tab === "library" && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("input", {
        type: "text",
        value: query,
        onChange: function onChange(e) {
          return setQuery(e.target.value);
        },
        placeholder: "Search ".concat(BLOCK_ICON_CATALOG.length, " icons..."),
        style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
          fontFamily: "DM Sans, sans-serif",
          fontSize: 14
        })
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(6, 1fr)",
          gap: 6,
          maxHeight: 180,
          overflowY: "auto",
          padding: 8,
          background: "#f8fafc",
          border: "1px solid ".concat(UI.surfaceBorder),
          borderRadius: 8
        },
        children: [filteredIcons.map(function (icon) {
          var active = (content === null || content === void 0 ? void 0 : content.iconName) === icon.id;
          return /*#__PURE__*/_jsx("button", {
            type: "button",
            title: icon.label,
            onClick: function onClick() {
              return onSelectSvg === null || onSelectSvg === void 0 ? void 0 : onSelectSvg(icon.id);
            },
            style: {
              border: active ? "2px solid #101828" : "1px solid ".concat(UI.surfaceBorder),
              borderRadius: 6,
              background: active ? "#101828" : "#ffffff",
              color: active ? "#ffffff" : "#101828",
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: 0
            },
            children: /*#__PURE__*/_jsx(BlockIcon, {
              content: {
                iconName: icon.id,
                size: "20px"
              },
              style: {
                color: active ? "#ffffff" : "#101828"
              }
            })
          }, icon.id);
        }), !filteredIcons.length && /*#__PURE__*/_jsx("div", {
          style: {
            gridColumn: "1 / -1",
            textAlign: "center",
            fontSize: 12,
            color: "#64748b",
            padding: 12
          },
          children: "No icons match your search."
        })]
      })]
    }), tab === "emoji" && /*#__PURE__*/_jsx("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        gap: 6,
        maxHeight: 180,
        overflowY: "auto",
        padding: 8,
        background: "#0f172a",
        border: "1px solid #334155",
        borderRadius: 8
      },
      children: ICON_EMOJI_PRESETS.map(function (sym) {
        var active = !(content !== null && content !== void 0 && content.iconName) && ((content === null || content === void 0 ? void 0 : content.symbol) || "★") === sym;
        return /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: function onClick() {
            return onSelectEmoji === null || onSelectEmoji === void 0 ? void 0 : onSelectEmoji(sym);
          },
          style: {
            background: active ? "#101828" : "transparent",
            border: active ? "1px solid #38bdf8" : "none",
            borderRadius: 4,
            fontSize: 18,
            padding: "6px 0",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#f1f5f9"
          },
          children: sym
        }, sym);
      })
    }), tab === "custom" && /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 8
      },
      children: [/*#__PURE__*/_jsx("label", {
        style: {
          fontSize: 14,
          fontWeight: 500,
          color: "#4b5563"
        },
        children: "Custom symbol or emoji"
      }), /*#__PURE__*/_jsx("input", {
        type: "text",
        value: content !== null && content !== void 0 && content.iconName ? "" : (content === null || content === void 0 ? void 0 : content.symbol) || "",
        onChange: function onChange(e) {
          return onCustomSymbol === null || onCustomSymbol === void 0 ? void 0 : onCustomSymbol(e.target.value);
        },
        placeholder: "Type any emoji or character, e.g. \u2605 or \u2713",
        style: _objectSpread(_objectSpread({}, panelInputStyle), {}, {
          fontFamily: "DM Sans, sans-serif",
          fontSize: 14
        })
      }), /*#__PURE__*/_jsx("p", {
        style: {
          margin: 0,
          fontSize: 12,
          color: "#64748b"
        },
        children: "Paste any emoji, Unicode symbol, or single character."
      })]
    })]
  });
}